import React from 'react';
import css from './BooleanFilter.module.css';
import classNames from 'classnames';

const getQueryParamName = queryParamNames => {
  return Array.isArray(queryParamNames) ? queryParamNames[0] : queryParamNames;
};

const BooleanFilter = props => {
  const { label, queryParamNames, initialValues, onSubmit } = props;

  const queryParamName = getQueryParamName(queryParamNames);

  const isSelected = !!initialValues?.[queryParamName];

  const handleClick = () => {
    const newValue = isSelected ? null : true;
    const queryParamUpdate = { [queryParamName]: newValue };
    onSubmit(queryParamUpdate);
  };

  const buttonClasses = classNames(css.label, {
    [css.labelSelected]: isSelected,
  });

  return (
    <button className={buttonClasses} onClick={handleClick}>
      {label}
    </button>
  );
};

export default BooleanFilter;
